import { sha256 } from "js-sha256";

const encrypt = (pass) => {
  return sha256(pass);
};

function supportsEmoji(emoji) {
  const ctx = document.createElement("canvas").getContext("2d");
  ctx.canvas.width = ctx.canvas.height = 1;
  ctx.fillText(emoji, -4, 4);
  return ctx.getImageData(0, 0, 1, 1).data[3] > 0; // Not a transparent pixel
}

console.log(supportsEmoji());

function passwordToEmojiSeed(password) {
  if (!password.length) return "";
  const passwordHash = sha256(password);
  const parts = [
    passwordHash.slice(0, 10),
    passwordHash.slice(10, 20),
    passwordHash.slice(20, 30),
  ];

  let values = [];
  for (var i of parts) {
    let x = 0;
    for (var j = 0; j < i.length; j++) {
      let myString = i.charCodeAt(j);
      let p = parseInt(myString, 16);
      if (x > 8) x *= p;
      else x += p;
      //literally completely random number used to keep the size of x low so that
      //the next % still works
      x = x % 202104;
    }
    //The number here effects how many emojis will be used
    x = x % 255;
    while (supportsEmoji(String.fromCodePoint(0x1f600 + x)) == false) {
      x = (x + 1) % 255;
    }

    values.push(x);
  }

  const first_emoji_unicode = 0x1f600;

  return values
    .map((value) => String.fromCodePoint(first_emoji_unicode + value))
    .join("");
}
const levenshteinDistance = (str1 = "", str2 = "") => {
  const track = Array(str2.length + 1)
    .fill(null)
    .map(() => Array(str1.length + 1).fill(null));
  for (let i = 0; i <= str1.length; i += 1) {
    track[0][i] = i;
  }
  for (let j = 0; j <= str2.length; j += 1) {
    track[j][0] = j;
  }
  for (let j = 1; j <= str2.length; j += 1) {
    for (let i = 1; i <= str1.length; i += 1) {
      const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1;
      track[j][i] = Math.min(
        track[j][i - 1] + 1, // deletion
        track[j - 1][i] + 1, // insertion
        track[j - 1][i - 1] + indicator // substitution
      );
    }
  }
  return track[str2.length][str1.length];
};
export { passwordToEmojiSeed, encrypt, levenshteinDistance };
